import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { productSwitchEasyConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';


@Component({
    selector: 'app-product-switch-easy',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSwitchEasyComponent implements OnInit {

  private readonly loginService = inject(LoginService);
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    const redirectUri = new URL(productSwitchEasyConfig.redirectUri!);
    const redirectPath = this.route.snapshot.data['redirectPath'];
    const params = this.route.snapshot.queryParams;
    const inApp = params['inApp'] ?? params['InApp'];

    if (redirectPath === 'kids-youth') {
      redirectUri.pathname = `${redirectUri.pathname.replace(/\/$/, '')}/kids-youth`;
    }
    if (inApp) {
      redirectUri.searchParams.set('inApp', 'true');
    }

    this.loginService.login({
      ...productSwitchEasyConfig,
      redirectUri: redirectPath || inApp ? redirectUri.toString() : productSwitchEasyConfig.redirectUri
    });
  }

}
